var dropZoneMixin = {
    data: function () {
        return {
            serverError: '',
            response: {
                success: false,
                failed: false
            }
        }
    },
    methods: {
        dropZone: function () {
            const vm = this;
            const appElement = '#' + vm.$el.id + ' '; // $el is the calling vue app

            const previewNode = document.querySelector(appElement + '#template');

            if (previewNode === null)
                return;

            previewNode.id = "";

            const previewTemplate = previewNode.parentNode.innerHTML;
            previewNode.parentNode.removeChild(previewNode);

            const errorBar = document.querySelector('#error-bar');

            new Dropzone(appElement + '#file-uploads', {
                url: '/Api/Uploads/UploadFiles',
                autoProcessQueue: false,
                uploadMultiple: true,
                parallelUploads: 100,
                previewTemplate: previewTemplate,
                previewsContainer: appElement + '#previews',
                acceptedFiles: 'image/png, image/jpeg, application/pdf, .eps, .dwg, .dxf',
                thumbnailWidth: 16,
                thumbnailHeight: 16,
                maxFilesExceeded: function (files) {
                    this.removeAllFiles();
                    this.addFile(files);
                },
                headers: {
                    '__requestverificationtoken': GLOBAL.ANTIFORGERYTOKEN
                },
                init: function () {
                    const dropZone = this;
                    var totalSize = 0;

                    dropZone.on("addedfile", function (file) {
                        totalSize += parseFloat((file.size / (1024 * 1024)).toFixed(2));

                        vm.setSendButtonState(totalSize)               
                    });
                    dropZone.on("removedfile", function (file) {
                        totalSize -= parseFloat((file.size / (1024 * 1024)).toFixed(2));

                        vm.setSendButtonState(totalSize)
                    });
                    dropZone.on("error", function (file, response) {
                        errorBar.classList.remove('d-none');
                        errorBar.querySelector('span').innerHTML = response;

                        //reset the progress bars and show the remove file icon
                        file.previewElement.querySelector(".progress ").classList.add('d-none');
                        file.previewElement.querySelector(".close ").classList.remove('d-none');

                    });
                    dropZone.on("sendingmultiple", function (file, xhr, formData) {

                    });
                    dropZone.on("errormultiple", function (files, response) {
                        errorBar.classList.remove('d-none');
                        errorBar.querySelector('span').innerHTML = response.message;
                    });
                    dropZone.on("sending", function (file) {
                        file.previewElement.querySelector(".progress ").classList.remove('d-none');
                        file.previewElement.querySelector(".close ").classList.add('d-none');
                    });

                }
            });
        },
        setSendButtonState: function (totalSize) {
            const button = document.querySelector('#upload-files-button');
            const errorBar = document.querySelector('#error-bar');

            if (totalSize >= 10) {
                button.disabled = true;
                button.classList.add('disabled');
                errorBar.classList.remove('d-none');
                errorBar.querySelector('span').innerHTML = dropZone_DATA.max10MBFilesReached;
            } else {
                button.disabled = false;
                button.classList.remove('disabled');
                errorBar.classList.add('d-none');
                errorBar.querySelector('span').innerHTML = "";
            }
        }
    }
}